/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `XENETA` - Xeneta
 * * `HISTORICAL_QUOTES` - Historical Quotes
 * * `LONG_SHORT_PRICE` - Long Short Price
 * * `DIRECT_LAND_ESTIMATE` - Direct Land Estimate Between Two Countries
 * * `HISTORICAL_AVERAGES` - Historical Averages
 * * `QUOTES_BASED_AVERAGES` - Quotes Based Averages
 * * `EXTERNAL_SOURCE_AVERAGES` - External Source Averages
 * * `FIRM_QUOTE` - Firm Quote
 */
export type TransportCostSource = typeof TransportCostSource[keyof typeof TransportCostSource];


export const TransportCostSource = {
  XENETA: 'XENETA',
  HISTORICAL_QUOTES: 'HISTORICAL_QUOTES',
  LONG_SHORT_PRICE: 'LONG_SHORT_PRICE',
  DIRECT_LAND_ESTIMATE: 'DIRECT_LAND_ESTIMATE',
  HISTORICAL_AVERAGES: 'HISTORICAL_AVERAGES',
  QUOTES_BASED_AVERAGES: 'QUOTES_BASED_AVERAGES',
  EXTERNAL_SOURCE_AVERAGES: 'EXTERNAL_SOURCE_AVERAGES',
  FIRM_QUOTE: 'FIRM_QUOTE',
} as const;
